module.exports = __webpack_public_path__ + "img/timeLine-two-backups.2dafef45.png";